// Helper function to strip XML blocks from human message display
export function stripXmlBlocks(content: string): string {
  return content
    .replace(/<document[^>]*>\n?[\s\S]*?\n?<\/document>/g, '')
    .replace(/<image[^>]*>\n?[\s\S]*?\n?<\/image>/g, '')
    .trim();
}
